<template>
<div>
    <Box @close="cerrar({})">
        <template #top>Nueva Asignación</template>
        <template #center>
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-title-1">Datos</div>
                    <div class="nj-grid">
                        <InputSelect label="Solicitante" v-model="asignacion_items.emp_solicitante" id="ai-solicitantes" :source="solicitantes" itemKey="emp_id" itemValue="emp_id"
                            :filterFunction="filterUsuario" :labelFunction="labelUsuario">
                            <template #default="data">
                                {{ labelUsuario(data.item) }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Autorizador" v-model="asignacion_items.emp_autorizador" id="ai-autorizadores" :source="autorizadores" itemKey="emp_id" itemValue="emp_id"
                            :filterFunction="filterUsuario" :labelFunction="labelUsuario">
                            <template #default="data">
                                {{ labelUsuario(data.item) }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Almacen" v-model="asignacion_items.alm_id" id="ai-almacenes" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacen"
                            :labelFunction="labelAlmacen">
                            <template #default="data">
                                {{ labelAlmacen(data.item) }}
                            </template>
                        </InputSelect>
                        <InputText label="Fecha registro" v-model="asignacion_items.ait_fecha_registro"></InputText>
                    </div>
                    <br>
                    <div class="nj-title-1">Items</div>
                    <SearchBox label="Item" itemKey="ord_id" itemValue="ord_id" :source="productos" :labelFunction="(item) => item.prv_nombre" id="ai-items" :searchFunction="buscarProducto"
                        @selectItem="agregarProducto">
                        <template #default="data">
                            {{ data.item.prv_nombre }}
                        </template>
                    </SearchBox>
                    <br>
                    <b-table :data="asignacion_items.lista_asignacion_items_detalle">
                        <template slot-scope="props">
                            <b-table-column label="Codigo" header-class="is-info">{{ props.row.pal_id }}</b-table-column>
                            <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                            <b-table-column label="Cantidad" header-class="is-info">
                                <input type="text" class="nj-text" v-model="props.row.aid_cantidad">
                            </b-table-column>
                            <b-table-column label="Observaciones" header-class="is-info">
                                <input type="text" class="nj-text" v-model="props.row.aid_notas">
                            </b-table-column>
                            <b-table-column label="Opciones" header-class="is-info" style="width: 80px;">
                                <div class="nj-flx">
                                    <button class="nj-button icon c-red" title="Retirar" @click="retirarProducto(props.row.pal_id)"><i class="mdi mdi-delete"></i></button>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </template>
        <template #bottom>
            <Button label="Registrar" icon="save" @click="registrar()"></Button>
        </template>
    </Box>
    <HistorialAsignaciones v-if="showHistorial" :filters="filters" :titulo="titulo" @close="closeHistorial()"></HistorialAsignaciones>
</div>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { AsignacionItemsService, EmpleadoService, ProductoAlmacenService, ResponseStatus, UsuarioService } from "../../rest"
import OpcionesService from "../../rest/OpcionesService"
import { Data, Validator } from "../../util"
import DateTime from "../../util/dateTime"
import Toast from "../../util/toast"
import { Box, Button, InputSelect, InputText, SearchBox } from "../components"
import HistorialAsignaciones from "./HistorialAsignaciones"

export default {
    name: "RegistrarAsignacionItems",
    components: {
        HistorialAsignaciones,
        Box,
        InputText,
        InputSelect,
        SearchBox,
        Button,
    },
    data() {
        return {
            asignacion_items: {
                usu_registrador: UsuarioService.getUsuario().usu_id,
                emp_solicitante: null,
                emp_autorizador: null,
                ait_fecha_registro: null,
                pry_id: UsuarioService.getUsuario().pry_id,
                alm_id: null,
                lista_asignacion_items_detalle: [],
            },
            emp_solicitante_nombre: null,
            filters: {
                emp_solicitante: null,
                prv_id: null,
                pal_id: null,
                alm_id: null
            },
            titulo: "",
            emp_autorizador_nombre: null,
            prv_nombre: null,
            showHistorial: false,
            solicitantes: [],
            autorizadores: [],
            productos: [],
            almacenes: [],
        }
    },
    methods: {
        cerrar(condition) {
            this.reiniciarListas()
            this.$emit("close", condition)
        },
        reiniciarListas() {
            this.solicitantes = []
            this.autorizadores = []
            this.productos = []
        },
        filterUsuario(items, param) {
            if (param != null && param != "") {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelUsuario(item) {
            return item.emp_nombre_completo
        },
        buscarEmpleado() {
            EmpleadoService
                .buscar({
                    empleado: {
                        pry_id: UsuarioService.getUsuario().pry_id,
                        epr_estado: EstadoEnum.ACTIVO.est_id
                    }
                })
                .then(response => {
                    this.autorizadores = response.data
                    this.solicitantes = response.data
                })
                .catch(error => {
                    Toast.error(error)

                })
        },
        filterAlmacen(items, param) {
            if (param != null && param != "") {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        buscarProducto(prv_nombre) {
            if (Validator.start(this.asignacion_items.alm_id)) {
                const request = {
                    producto_almacen: {
                        prv_nombre,
                        alm_id: this.asignacion_items.alm_id
                    }
                }
                ProductoAlmacenService
                    .buscarRapido(request).then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.productos = response.data
                        }
                        else {
                            Toast.warn(response.message)
                        }
                    }).catch(error => {
                        Toast.error(error)

                    })
            }
            else {
                Toast.warn("Debe seleccionar un almacén")
            }
        },
        agregarProducto(item) {
            const prod = this.asignacion_items.lista_asignacion_items_detalle.find(i => i.pal_id == item.pal_id)
            if (!prod) {
                this.asignacion_items.lista_asignacion_items_detalle.push({
                    prv_id: item.prv_id,
                    pal_id: item.pal_id,
                    prv_nombre: item.prv_nombre,
                    aid_cantidad: 1,
                })
                this.productos = []
            }
            else {
                Toast.warn("El producto ya ha sido agregado")
            }
        },
        retirarProducto(pal_id) {
            this.asignacion_items.lista_asignacion_items_detalle =
                this.asignacion_items.lista_asignacion_items_detalle.filter(item => item.pal_id != pal_id)
        },
        registrar() {
            if (Validator.start(
                this.asignacion_items.emp_solicitante,
                this.asignacion_items.emp_autorizador,
                this.asignacion_items.ait_fecha_registro,
                this.asignacion_items.pry_id,
                this.asignacion_items.alm_id,
                this.asignacion_items.lista_asignacion_items_detalle,
            )) {
                AsignacionItemsService
                    .registrar({
                        asignacion_items: this.asignacion_items
                    })
                    .then(response => {
                        Toast.success(response.message)
                        this.cerrar(true)
                    })
                    .catch(error => {
                        Toast.error(error)

                    })
            }
            else {
                Toast.warn("Faltan ingresar datos para la asignación")
            }
        },
        openHistorialxSolicitante(solicitante) {
            this.showHistorial = true
            this.titulo = "Historial de asignaciones por solicitante"
            this.filters.emp_solicitante = solicitante.emp_id
        },
        openHistorialxItem(item) {
            this.showHistorial = true
            this.titulo = "Historial de asignaciones por item"
            this.filters.pal_id = item.pal_id
        },
        closeHistorial() {
            this.showHistorial = false
            this.filters.pal_id = null
        },
    },
    mounted() {
        this.asignacion_items.ait_fecha_registro = DateTime.todayString()
        OpcionesService
            .getOpciones({
                almacen: {
                    pry_id: UsuarioService.getUsuario().usu_nivel == 1 ? null : UsuarioService.getUsuario().pry_id
                },
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.almacenes = response.data.almacenes
                    this.asignacion_items.pry_id = UsuarioService.getUsuario().pry_id
                    this.buscarEmpleado()
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },
}
</script>

<style scoped></style>